import React from 'react';
import PropTypes from 'prop-types';
import Translation from '../../../translation/translation';

function AllGiven({ onLearnMoreClick }) {
    return (
        <div className="statusbar-mobile__missing-status statusbar-mobile__missing-status--all-given">
            <Translation translationKey="catalog-missing-status-speed-load-index-hint" />
            {' '}
            <Translation
                translationKey="catalog-missing-status-speed-load-index-learn-more"
                className="statusbar-mobile__learn-more-link"
                onClick={onLearnMoreClick}
            />
        </div>
    );
}

AllGiven.propTypes = {
    onLearnMoreClick: PropTypes.func.isRequired,
};

export { AllGiven };
